import React, { useEffect, useRef, useState } from 'react';
import './create-eval-form-v2.styles.scss'
import { Sources } from '../../../forms/formTypes';
import { UseCloudFunction } from '../../../utils/firebase.utils';
import { getQueryFromFirestore } from '../../../utils/getDataFromDbSimplified';
import FullPageLoader from '../../SHARED/loader/full-page-loader.component';
import { useNavigate, useParams } from 'react-router-dom';
import { createPathFromTimestamp } from '../../../utils/createPathFromTimestamp';
import { ModalAlert, ModalConfirm } from '../../modal/modal.component';

const CreateEvalFormV2 = () => {

  const [formData, setFormData] = useState({});
  const [resultList, setResultList] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [questionSets, setQuestionSets] = useState([]);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const approveRef = useRef(() => { });
  const { evalPath } = useParams();
  const dataRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    getQuestionSets();
  }, [])

  useEffect(() => {
    if (!evalPath) return;
    getEvalData();
  }, [evalPath])

  function getEvalData() {
    getQueryFromFirestore({
      'path': 'evaluations_v2',
      'queryArray': [{
        'field': 'path',
        'operator': '==',
        'value': evalPath
      }],
      'callback': callback,
      'once': true
    })
    function callback(data) {
      console.log(data);
      const evalData = Object.values(data)[0];
      dataRef.current = { ...evalData };
      setFormData(dataRef.current);
      if (evalData.itemId) {
        chooseItem(evalData.itemId);
      }
    }
  }

  function getQuestionSets() {
    getQueryFromFirestore({
      'path': 'forms_data',
      'queryArray': [{
        'field': 'type',
        'operator': '==',
        'value': 'questionSet'
      },
      {
        'field': 'status',
        'operator': '==',
        'value': 'active'
      }],
      'callback': callback,
      'once': true
    })
    function callback(data) {
      console.log(data);
      setQuestionSets(Object.values(data));
    }
  }

  function saveData(key, value) {
    if (key === 'source') {
      dataRef.current = {
        source: value,
      }
    }
    if (key === 'description' || key === 'title') {
      dataRef.current = {
        ...dataRef.current,
        item: {
          ...dataRef.current.item,
          [key]: value
        }
      }
    } else {
      dataRef.current = {
        ...dataRef.current,
        ...{ [key]: value }
      };
    }
    setFormData(dataRef.current);
    console.log(dataRef.current);
  }

  async function search() {
    setLoading(true);
    delete dataRef.current.comps
    delete dataRef.current.item
    delete dataRef.current.itemId
    delete dataRef.current.type
    setFormData({
      ...dataRef.current, ...{
        'cpdu': false,
        'hours': 0
      }
    });
    setResultList(null)
    const source = dataRef.current.source;
    if (source === 'bridge') {
      const text = document.getElementById('search-text').value;
      console.log(text)
      const url = `https://eln.bridgeapp.com/api/learner/library_items?search=${text}&sort=title`
      const res = await UseCloudFunction('getBridgeCourses', { 'url': url })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList(res.library_items)
      setLoading(false);
    } else if (source === 'odaa') {
      let text = 'AA';
      console.log(text)
      const url = `https://eln.bridgeapp.com/api/author/programs?search=${text}&sort=newest`
      const res = await UseCloudFunction('getBridgePrograms', { 'url': url })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList(res.programs)
      setLoading(false);
    } else if (source === 'zoomWebinar') {
      let url = `https://api.zoom.us/v2/users/arlin@ilprincipals.org/webinars`

      let res = await UseCloudFunction('getZoomWebinars', { 'url': url })
      console.log(res)
      if (res.results.nextPageToken) {
        setNextUrl(res.results.nextPageToken)
      } else {
        setNextUrl(null)
      }
      let arr = []
      for (let web of res.results.webinars) {
        arr.push({
          'id': web.id,
          'title': web.topic,
          'date': new Date(web.start_time).getTime(),
          'description': web.agenda
        })
      }

      url = `https://api.zoom.us/v2/users/arlin@ilprincipals.org/meetings`

      res = await UseCloudFunction('getZoomWebinars', { 'url': url })
      console.log(res)
      if (res.results.nextPageToken) {
        setNextUrl(res.results.nextPageToken)
      } else {
        setNextUrl(null)
      }

      for (let web of res.results.meetings) {
        arr.push({
          'id': web.id,
          'title': web.topic,
          'date': new Date(web.start_time).getTime(),
          'description': web.agenda
        })
      }
      arr.sort((a, b) => a.date < b.date ? 1 : -1)
      setResultList(arr)
      setLoading(false);
    } else if (source === 'mc') {
      let res = await UseCloudFunction('getMCs', { 'url': 'data' })
      console.log(res)
      let arr = [];
      for (let mc of res.list) {
        arr.push({
          'id': mc.evt_key,
          'title': mc.evt_title || "No title",
          'date': new Date(mc.evt_start_date).getTime(),
          'description': ''
        })
      }
      console.log(arr);
      arr.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1)
      setResultList(arr)
      setLoading(false);
    }
  }

  async function getMoreResults() {
    setLoading(true)
    const source = formData.source;
    if (source === 'bridge') {
      const res = await UseCloudFunction('getBridgeCourses', { 'url': nextUrl })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList([...resultList, ...res.library_items])
      setLoading(false)
    }
    if (source === 'aa') {
      const res = await UseCloudFunction('getBridgePrograms', { 'url': nextUrl })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList([...resultList, ...res.programs])
      setLoading(false)
    }
  }

  function chooseItem(id) {

    const items = document.getElementsByClassName('result-list-item')
    for (let i of items) {
      i.classList.remove('selected')
    }
    document.getElementById(id).classList.add('selected')
    let item;
    for (let r of resultList) {
      if (`${dataRef.current.source}-${r.id}` === `${dataRef.current.source}-${id}`) {
        item = {
          'title': r.title,
          'description': r.description
        }
      }
    }
    dataRef.current = {
      ...dataRef.current, ...{
        'item': item,
        'itemId': `${dataRef.current.source}-${id}`
      }
    };
    setFormData({ ...dataRef.current });
  }

  async function saveEvaluation() {

    console.log(dataRef.current)
    let obj = { ...dataRef.current }
    if (!obj.source || (obj.source !== 'custom' && !obj.itemId)) {
      setAlertMessage('Please select a source and item for this evaluation.')
      return;
    }
    if (!obj.item.title || !obj.pres || (obj.questionSets || []).length === 0) {
      setAlertMessage('Please make sure to fill out the title, presenters, and question sets for this evaluation.');
      return;
    }
    if (obj.cpdu && (!obj.hours || obj.hours <= 0)) {
      setAlertMessage('Please enter a valid number of hours for the CPDU evidence document.')
      return;
    }
    setConfirmMessage('Are you sure you want to create this evaluation?')
    approveRef.current = () => {
      continueSaving();
    }

    async function continueSaving() {
      setLoading(true);
      if (!obj.path) {
        obj.path = createPathFromTimestamp();
      }
      if (
        obj.source === 'checkinout' ||
        obj.source === 'custom'
      ) {
        obj.itemId = `${obj.source}-c${obj.id}`
      } else {
        for (let r of resultList) {
          console.log(r)
          if (r.id === formData.itemId) {
            obj.item = r
            break;
          }
        }
      }
      obj = {
        ...obj,
        ...{
          'status': 'active',
          'platform': 'eln',
          'ts': new Date().getTime()
        }
      }
      console.log(obj)
      const res = await UseCloudFunction('saveAdminEval', { 'obj': obj })
      console.log(res)
      if (res.message === 'eval saved successfully') {
        setAlertMessage('Evaluation saved successfully!');
        approveRef.current = () => {
          navigate(`/admin/evals`)
        }
      } else if (res.message === 'eval already exists') {
        setAlertMessage('An evaluation already exists for this event.')
      } else {
        setAlertMessage('Something went wrong...')
      }
      setLoading(false);
    }
  }

  return (
    <div className='create-eval-v2-container'>
      <div className='field'>
        <label>Choose a Source</label>
        <select
          className="uk-select"
          aria-label="Select a Source"
          value={(formData && formData.source) ? formData.source : ''}
          onChange={(e) => saveData('source', e.target.value)} >
          <option value=''>Choose...</option>
          {
            (Sources)
              ?
              Object.values(Sources)
                .sort((a, b) => (a.title > b.title) ? 1 : -1)
                .map(source => (
                  <option
                    key={source.id}
                    value={source.id}>
                    {source.title}
                  </option>
                ))
              : ''
          }
          <option value='custom'>Custom Evaluation</option>
        </select>
      </div>
      {/* once source is chosen, display search and results for non-custom */}
      {
        (
          formData &&
          formData.source !== 'custom'
        ) &&
        <div>
          <div className="g-space-1"></div>
          <div className="">

            {
              (formData && (formData.source === 'bridge') && !evalPath) &&
              <>
                <label>Find an Event to Evaluate</label>
                <input
                  className="uk-input"
                  id='search-text'
                  aria-label="Search for an Event to Evaluate" />
              </>
            }
            <div className="g-space-1"></div>
            <button
              className='g-button button-small'
              id='search-button'
              onClick={() => search()}>
              Search
            </button>
            <div className="g-space-1"></div>
          </div>

          {
            (resultList && (!formData || !formData.itemId))
              ?
              <div
                className='result-card result-list'
                id='search-results'>
                {
                  resultList.map(r => (
                    <div
                      key={r.id}
                      className='result-list-item'
                      id={r.id}
                      onClick={(e) => chooseItem(e.target.id)}>
                      {r.title}
                    </div>
                  ))
                }
                {
                  (nextUrl)
                    ?
                    <div
                      className='result-list-item'
                      onClick={() => getMoreResults()}>
                      <b>Load more...</b>
                    </div>
                    : ''
                }

              </div>
              : ''
          }
        </div>
      }
      {/* 
        once an item is chosen or custom source is selected, display 
        other fields 
      */}
      {
        (
          formData &&
          (
            (formData.itemId && formData.item) ||
            formData.source === 'custom'
          )
        )
        &&
        <>
          {/* if item is chosen, display title and description */}
          {
            (
              formData.item &&
              formData.source !== 'custom'
            ) &&
            <div className='uk-margin'>
              <h4><b>{formData.item.title}</b></h4>
              <p>{formData.item.description}</p>
            </div>
          }

          {/* if source is custom, show inputs for title and description */}
          {
            (
              formData.source === 'custom'
            ) &&
            <div>
              <div className="g-space-1"></div>
              <div className='field'>
                <label>Title</label><br />
                <input
                  className="uk-input"
                  type='text'
                  id='title'
                  aria-label="Title of Custom Evaluation"
                  value={
                    formData?.item?.title
                      ? formData.item.title
                      : ''
                  }
                  onChange={(e) => saveData('title', e.target.value)} />
              </div>
              <div className="g-space-1"></div>
              <div className='field'>
                <label>Description</label><br />
                <input
                  className="uk-input"
                  type='text'
                  id='description'
                  aria-label="Description of Custom Evaluation"
                  value={
                    formData?.item?.description
                      ? formData.item.description
                      : ''
                  }
                  onChange={(e) => saveData('description', e.target.value)} />
              </div>
            </div>
          }
          {/* show input for presenters */}
          <div className='uk-margin'>
            <label>Presenter(s)</label><br />
            <input
              className="uk-input"
              type='text'
              id='presenters'
              aria-label="Name of Presenter"
              value={
                (formData && formData.pres)
                  ? formData.pres
                  : ''
              }
              onChange={(e) => saveData('pres', e.target.value)} />
          </div>

          <div className="g-space-0-5"></div>
          {/* toggle for limiting access to one eval per user */}
          <div className='toggle-row'>
            <label className='toggle-switch'>
              <input
                type="checkbox"
                id="limitOncePerUser"
                checked={formData.limitOncePerUser ? true : false}
                onChange={(e) => saveData('limitOncePerUser', e.target.checked)} />
              <span className='toggle-track'>
                <span className='toggle-thumb' />
              </span>
            </label>
            <div className='toggle-label'>
              <span>One Evaluation Per User</span>
              <div className='toggle-meta'>
                If checked, users will only be able to complete this evaluation once.
                If unchecked, users can complete multiple evaluations for the same item.
              </div>
            </div>
          </div>


          {/* toggle for creating evidence of completion document */}
          <div className='toggle-row'>
            <label className='toggle-switch'>
              <input
                type="checkbox"
                id="cpdu"
                checked={formData.cpdu ? true : false}
                onChange={(e) => saveData('cpdu', e.target.checked)} />
              <span className='toggle-track'>
                <span className='toggle-thumb' />
              </span>
            </label>
            <div className='toggle-label'>
              <span>Create Evidence of Completion Document</span>
              <div className='toggle-meta'>
                Learners will be prompted to choose their State and the date of the event.
              </div>
            </div>
          </div>
          {
            (formData && formData.cpdu) &&
            <div className='hours-field'>
              <label htmlFor='hours'>Number of Hours for Evidence</label>
              <input
                type='number'
                id='hours'
                aria-label="Number of hours"
                className='hours-input'
                value={(formData && formData.hours) ? formData.hours : 0}
                onChange={(e) => saveData('hours', e.target.value)} />
            </div>
          }
          <div className='g-space-0-5'></div>
          {/* two-panel ordered selector for question sets */}
          <div className='uk-margin qs-selector'>
            <label>Question Sets</label>
            <div className='qs-panels'>
              <div className='qs-panel qs-available'>
                <div className='qs-panel-header'>Available</div>
                {questionSets
                  .filter(qs => !(formData.questionSets || []).includes(qs.id))
                  .map(qs => (
                    <div
                      key={qs.id}
                      className='qs-panel-item'
                      onClick={() => saveData('questionSets', [...(formData.questionSets || []), qs.id])}
                    >
                      <span>{qs.name}</span>
                      <button className='qs-add-btn' tabIndex={-1}>+</button>
                    </div>
                  ))
                }
              </div>
              <div className='qs-panel qs-selected'>
                <div className='qs-panel-header'>Selected (in display order)</div>
                {(formData.questionSets || []).map((id, index) => {
                  const qs = questionSets.find(q => q.id === id);
                  if (!qs) return null;
                  const list = formData.questionSets;
                  return (
                    <div key={id} className='qs-panel-item'>
                      <div className='qs-order-buttons'>
                        <button
                          disabled={index === 0}
                          onClick={() => {
                            const updated = [...list];
                            [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
                            saveData('questionSets', updated);
                          }}
                        >▲</button>
                        <button
                          disabled={index === list.length - 1}
                          onClick={() => {
                            const updated = [...list];
                            [updated[index + 1], updated[index]] = [updated[index], updated[index + 1]];
                            saveData('questionSets', updated);
                          }}
                        >▼</button>
                      </div>
                      <span>{qs.name}</span>
                      <button
                        className='qs-remove-btn'
                        onClick={() => saveData('questionSets', list.filter(i => i !== id))}
                      >×</button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className='buttons'>
            <button
              className={`g-button `}
              onClick={() => saveEvaluation()}>
              Save Evaluation
            </button>
          </div>
        </>

      }
      <ModalAlert
        show={!!alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
        onApprove={approveRef.current} />
      <ModalConfirm
        show={!!confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default CreateEvalFormV2